<template>
  <SidePopup
    title="Atualizar estoque de segurança em massa"
    v-on:close="onClose"
    @submit="onSubmit"
    overlay-not-back
  >
    <FormSelect
      label="Tipo de cálculo"
      v-model="tipo_calculo"
      :options="tipoCalculoOptions"
      clearable
    />
    <FormField
      label="Valor aplicado"
      v-model="valor_aplicado"
      typeField="number"
      :min="0"
      placeholder="Informe o valor"
    />
    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import FormButton from "@/components/form/FormButton";
import FormSelect from "@/components/form/FormSelect";
import FormField from "@/components/form/FormField";

export default {
  name: "EstoqueSegurancaModal",
  components: { SidePopup, FormButton, FormSelect, FormField },
  data: () => ({
    tipo_calculo: null,
    valor_aplicado: null,
    tipoCalculoOptions: [
      { text: "Percentual", value: "percentual" },
      { text: "Fixo", value: "fixo" }
    ]
  }),
  methods: {
    onSubmit() {
      let tipo_calculo = this.tipo_calculo;
      if (
        tipo_calculo === undefined ||
        tipo_calculo === null ||
        tipo_calculo === ""
      ) {
        tipo_calculo = null;
      }

      let valor_aplicado = this.valor_aplicado;
      if (
        valor_aplicado !== undefined &&
        valor_aplicado !== null &&
        valor_aplicado !== ""
      ) {
        valor_aplicado =
          typeof valor_aplicado === "string"
            ? parseFloat(valor_aplicado)
            : Number(valor_aplicado);
        if (isNaN(valor_aplicado)) {
          valor_aplicado = null;
        }
      } else {
        valor_aplicado = null;
      }

      this.$emit("submit", {
        tipo_calculo: tipo_calculo,
        valor_aplicado: valor_aplicado
      });
    },
    onClose() {
      this.tipo_calculo = null;
      this.valor_aplicado = null;
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.seletor {
  margin: 0px !important;
  .v-input__slot {
    margin: 0px !important;
  }
  .v-messages {
    display: none !important;
  }
}
</style>
